import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Marketplace, MarketPlaceDataLogic, MarketPlaceNonTransactionalFlow, MarketPlaceStandardFlow } from 'app/infrastructure/model/classes/marketplace.class';
import {
  MarketplaceService,
  MARKETPLACE_ITEMTYPE_AllOfThem,
  MARKETPLACE_ITEMTYPE_StandardFlow,
  MARKETPLACE_ITEMTYPE_NonTransactionalFlow,
  MARKETPLACE_ITEMTYPE_BusinessLogic,
  MARKETPLACE_ITEMTYPE_DataLogic,
  MARKETPLACE_ITEMTYPE_ChannelReportConfiguration,
  MARKETPLACE_ITEMTYPE_StandardProductReport,
  MARKETPLACE_ITEMTYPE_StandardProductEmail,
  MARKETPLACE_ITEMTYPE_ViewEngines,
  MARKETPLACE_ITEMTYPE_Connections, MARKETPLACE_ITEMTYPE_StandardDictionary
} from 'app/infrastructure/services/marketplace.service';

@Component({
  selector: 'marketplace-card',
  templateUrl: './marketplace-card.component.html',
  styleUrls: ['./marketplace-card.component.scss'],
})
export class MarketplaceCard implements OnInit {
  @Input() model: Marketplace ;
  @Input() onSubscription: boolean = false;
  @Output() subscriptionEvent: EventEmitter<object> = new EventEmitter();
  @Output() deleteEvent: EventEmitter<Marketplace> = new EventEmitter();
  @Output() isExpanded: EventEmitter<Object> = new EventEmitter();
  itsOpen: boolean;

  constructor(
    public router: Router,
    protected route: ActivatedRoute,
    public marketplaceService: MarketplaceService
  ) {}

  ngOnInit() {}

  openIt(model: Marketplace) {
    this.itsOpen = true;
    this.isExpanded.emit({
      id: model.id,
      expand: this.itsOpen,
    });
  }

  closeIt(model: Marketplace) {
    this.itsOpen = false;
    this.isExpanded.emit({
      id: model.id,
      expand: this.itsOpen,
    });
  }

  goEdit(model: Marketplace) {
    switch (model.type) {
        
      case MARKETPLACE_ITEMTYPE_StandardFlow:
        this.router.navigate(['../Policy/standardFlows/',model.code], { relativeTo: this.route.parent});
        break;
        
      case MARKETPLACE_ITEMTYPE_NonTransactionalFlow:
        this.router.navigate(['../nontransactionalflows/',model.code], { relativeTo: this.route.parent});
        break;

      case MARKETPLACE_ITEMTYPE_BusinessLogic:
        this.router.navigate(['../businessLogic/',model.id], { relativeTo: this.route.parent});
        break;

      case MARKETPLACE_ITEMTYPE_DataLogic:
        this.router.navigate(['../dataLogic/',model.id], { relativeTo: this.route.parent});
        break;

      case MARKETPLACE_ITEMTYPE_ChannelReportConfiguration:
        this.router.navigate(['../configurationCenter/confReport/',model.id], { relativeTo: this.route.parent});
        break;

      case MARKETPLACE_ITEMTYPE_StandardProductReport:
        this.router.navigate(['../configurationCenter/confProductReport/',model.id], { relativeTo: this.route.parent}); 
        break;

      case MARKETPLACE_ITEMTYPE_StandardProductEmail:
        this.router.navigate(['../configurationCenter/emails/',model.id], { relativeTo: this.route.parent}); 
        break;

      case MARKETPLACE_ITEMTYPE_ViewEngines:
        this.router.navigate(['../viewengine/',model.id], { relativeTo: this.route.parent}); 
        break;

      case MARKETPLACE_ITEMTYPE_StandardDictionary:
        this.router.navigate(['../standarddictionary/',model.id], { relativeTo: this.route.parent});
        break;
      
    }    
  }

  subscription(model : Marketplace){
    this.subscriptionEvent.emit(model);
  }

  goDelete(model : Marketplace) {
    this.deleteEvent.emit(model);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/marketplace/marketplace-card/marketplace-card.component.ts